'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './post-list.routes';

export class ForumPostListComponent {
  constructor($state, $stateParams, Auth, ForumService, $uibModal, StorageService, $location, Config) {
    'ngInject';

    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.ForumService = ForumService;
    this.$uibModal = $uibModal;
    this.Auth = Auth;
    this.StorageService = StorageService;
    this.$location = $location;

    this.isAdmin = Auth.isAdminSync;
    this.userId = Auth.getCurrentUserSync()._id;

    this.cat = $stateParams.cat || 'general';

    this.catDefs = Config.getModuleConfig(Config.Modules.Forum).getCategories();

    this.toolbarDefinition = [
      ["bold","italics","underline","strikeThrough"],
      ["p","pre","quote","clear"],
      ["ul","ol"],
      ["undo","redo"],
      ["insertLink"]
    ];

    this.post = {
      attachments: [],
      category: this.cat,
      meta: {
        creationUser: Auth.getCurrentUserSync()._id
      }
    };

    //this.currentPage = 1;
    //this.itemsPerPage = (appConfig.pagination && appConfig.pagination.bulletin) || 10;

    this.pageTitle = (this.catDefs[this.cat] && this.catDefs[this.cat].name) ? this.catDefs[this.cat].name : "Forum";

    this.data = [];

    this.reloadData();

    //this.BulletinService = BulletinService;

    /*
    BulletinService.query(data => {
      this.data = data;

      this.categories.forEach(cat => {
        this.dataPerCategory[cat] = this.data.filter(post => {
          return post.categories.indexOf(cat) !== -1;
        });
      });

    }, err => {
      console.log('Could not retrieve bulletin board posts from server');
    });
    */
  }

  isCreator(data) {
    return data.meta.creationUser._id == this.userId;
  }

  reloadData() {
    this.ForumService.queryByCategory({cat: this.cat}, data => {
      this.data = data;
    });
  }

  getPreviewText(value) {
    let limit = 300;

    if (value) {

      let modifiedValue = value.replace(/<.+?>/g, ' ');

      if (value.length > limit) {

        modifiedValue = modifiedValue.substring(0, limit);
        modifiedValue = `${modifiedValue.substring(0, modifiedValue.lastIndexOf(' '))} …`;

      }

      return modifiedValue;

    }

    return value;
  }

  create(form) {
    this.ForumService.save(this.post, (newPost) => {
      this.$location.url("/forum/"+ this.cat + "/" + newPost._id);
    }, (err) => {
      console.error(err);
    });
  }

  removeAsset(idx) {
    this.post.attachments.splice(idx,1);
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  openAssetBrowserModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetBrowser',
      resolve: {
        config: function() {
          return {
            restrictToUserAssets: !that.Auth.isAdminSync(),
            userId: that.Auth.getCurrentUserSync()._id
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (newlySelectedAssets) {
        that.post.attachments = that.post.attachments.concat(newlySelectedAssets);
      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal = function () {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {
            acceptedFileTypes: 'application/pdf,image/*'
          }
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        result.forEach(storageId => {
          that.StorageService.getMeta({id: storageId}, data => {
            that.post.attachments.push(data);
          }, err => {
            console.log('could not retrieved storage from server');
          });

        });

      },
      function () { /* cancel */ }
    );

  }

}

export default angular.module('conduuApp.forumPostList', [uiRouter])
  .config(routes)
  .component('forumPostList', {
    template: require('./post-list.html'),
    controller: ForumPostListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/forum/list/post-list.component.js